/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import FolderSelector, {FolderSelectorProps} from 'file-browser/FolderSelector';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export interface FolderSelectorViewOptions extends Backbone.ViewOptions<Backbone.Model> {
  initialFolderId: string | number | null | undefined;
  inputClassName: string;
  inputData?: {index: number};
  props: Partial<FolderSelectorProps>;
}

class FolderSelectorView extends Backbone.View<Backbone.Model> {
  $container!: JQuery;
  $input!: JQuery;
  folderId!: string | number | null | undefined;
  initialFolderId!: string | number | null | undefined;
  inputClassName!: string;
  inputData?: {index: number} | null;
  props!: Partial<FolderSelectorProps>;

  static initClass(): void {
    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
      // The Backbone types do not know about this.
      'change input[type=hidden]': 'renderComponent',
    };
  }

  override initialize({initialFolderId, inputClassName, inputData, props}: FolderSelectorViewOptions): void {
    this.inputClassName = inputClassName;
    this.inputData = inputData;
    this.props = props;
    this.onChange = this.onChange.bind(this);
    this.folderId = initialFolderId;
    if (this.inputClassName == null) {
      this.inputClassName = 'folder-selector-view-input';
    }
    if (this.inputData == null) {
      this.inputData = null;
    }
    if (this.props == null) {
      this.props = {};
    }
  }

  override remove(): Backbone.View<Backbone.Model> {
    ReactDOM.unmountComponentAtNode(this.$container[0]);
    return super.remove();
  }

  onChange(e: JQueryEventObject): void {
    // @ts-expect-error `JQueryEventObject.target` is the narrow `Element`; this is in fact an `input` and has
    // a `value`
    this.$('input[type=hidden]').val(e.target.value).trigger('change');
  }

  renderComponent(): void {
    // Component expects null, not empty string.
    const value = this.$input.val() || null;
    // eslint-disable-next-line no-restricted-syntax
    const props = _.extend({}, this.props, {
      value,
      // eslint-disable-next-line @typescript-eslint/unbound-method -- this is bound in the constructor
      onChange: this.onChange,
    });
    if (props.unsetOnFetchFail == null) {
      props.unsetOnFetchFail = true;
    }
    renderToDOM(<FolderSelector {...props} />, this.$container[0]);
  }

  override render(): this {
    this.$input = $('<input>')
      .attr({type: 'hidden', value: this.folderId})
      .addClass(this.inputClassName)
      // @ts-expect-error You can, but should not, pass nullish values to `JQuery.data`
      .data(this.inputData);
    this.$container = $('<div>');
    this.renderComponent();
    // @ts-expect-error You can, but should not, pass JQuery objects to `JQuery.html`
    this.$el.html(this.$input).append(this.$container);
    return this;
  }
}
FolderSelectorView.initClass();

export default FolderSelectorView;
